import { applyExplicitUserLanguage } from "@/lib/languagePolicy";
import type { SupportedLanguage } from "@/lib/languages";
import { normalizeLanguageCode } from "@/lib/languages";
import { getEffectiveSiteLanguage } from "@/lib/siteLanguage";
import { useTranslation } from "react-i18next";

/**
 * Idioma del sitio alineado con i18next: traducciones + locale efectivo (p. ej. es-AR en Argentina).
 * ?lang= lo gestiona LanguageUrlSync en la app (una sola vez, coherente con languagePolicy).
 */
export function useLanguage() {
  const { i18n } = useTranslation();

  const i18nLang = i18n.resolvedLanguage || i18n.language;
  const language = getEffectiveSiteLanguage(i18nLang);
  const currentLanguage = normalizeLanguageCode(i18nLang) as SupportedLanguage;

  const changeLanguage = (lng: SupportedLanguage) => {
    applyExplicitUserLanguage(i18n, lng);
  };

  return {
    language,
    currentLanguage,
    changeLanguage,
    setLanguage: changeLanguage,
    isReady: i18n.isInitialized,
  };
}
